// File: assets/discount-implementation.js
(() => {
  // CONFIGURATION
  const config = {
    // 1. Cookie values that activate the script
    validDiscountCodes: [
      'jajco',
      'Summer Sale',
      'vipblack' // Black Friday Code
    ],
    
    // 2. Selectors
    discountTagPrefix: 'discount',
    dataAttributeHostSelector: '.product-area, .product-block',
    
    priceSelectors: {
      priceContainer: '.price, .price-area',
      currentPrice: 'span.theme-money:not(.was-price), .current-price',
      wasPrice: 'span.was-price'
    },
    
    // 3. EXCLUDED GIFT CARDS (Restored from your file)
    giftCards: {
      productIds: [
        '7455753797857',
        '7095346430136',
        '7203288350888'
      ],
      variantIds: [
        '42082446475489', '42082446508257', '42082446541025', '42082446573793', '42082453553377',
        '41291910873272', '41291910906040', '41291910938808', '41291910971576', '41291911004344',
        '41543308869800', '41543308902568', '41543308935336', '41543308968104', '41543309000872'
      ]
    }
  };

  // --- End of Configuration ---

  const discountManager = new ShopifyDiscountManager(config);
  let isUpdating = false;

  const updateProductPrice = () => {
    if (isUpdating) return;
    const priceArea = document.querySelector('.price-area');
    if (priceArea) {
      isUpdating = true;
      // We DO NOT delete dataset.priceId here anymore to prevent the 36% off bug.
      discountManager.updatePriceElement(priceArea);
      setTimeout(() => { isUpdating = false; }, 100);
    }
  };

  const initialize = () => {
      setTimeout(() => {
      discountManager.init();
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // Observer for fast variant changes
  const priceAreaObserver = new MutationObserver((mutations) => {
    if (isUpdating) return;
    for (const mutation of mutations) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        setTimeout(updateProductPrice, 50);
        break;
      }
    }
  });

  const startObservingPriceArea = () => {
    const priceArea = document.querySelector('.price-area');
    if (priceArea) {
      priceAreaObserver.observe(priceArea, { childList: true, subtree: true, characterData: true });
    }
  };
  
  window.addEventListener('load', startObservingPriceArea);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.price')) {
      discountManager.init();
      startObservingPriceArea();
    }
  });

  // LISTEN FOR VARIANT CHANGE: Reset the "original price" memory here
  document.addEventListener('variant:change', () => {
    const priceArea = document.querySelector('.price-area');
    if (priceArea && priceArea.dataset.priceId) {
       discountManager.originalPrices.delete(priceArea.dataset.priceId);
       delete priceArea.dataset.priceId;
    }
    setTimeout(updateProductPrice, 100);
  });

})();